import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/app.css';
import { I18nProvider } from './i18n/index.jsx';
import { SessionProvider } from './lib/session.jsx';
import { FlowProvider } from './lib/flow.jsx';
import { ToastProvider } from './lib/toast.jsx';
import { TopUpProvider } from './lib/topup.jsx';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nProvider>
      <SessionProvider>
        <FlowProvider>
          <ToastProvider>
            <TopUpProvider>
              <App />
            </TopUpProvider>
          </ToastProvider>
        </FlowProvider>
      </SessionProvider>
    </I18nProvider>
  </React.StrictMode>
);
